import { ToError } from './error-mappings';

export * from './error-mappings';

export const mappings: any[] = [ToError];
